export default Object.freeze({
  TITLE: '탈퇴 회원입니다.',
  CLOSE: '닫기'
});
